import { theme } from '@superhi/design'
import styled from 'styled-components'

const SPACING = 16

export const Items = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const Item = styled.div`
  width: calc(50% - ${SPACING * 2}px);
  display: flex;
  margin: 8px;
  align-items: center;
  justify-content: center;
  margin: ${SPACING}px;

  @media ${theme.breakpoints.medium} {
    width: calc(33.333% - ${SPACING * 2}px);
  }

  @media ${theme.breakpoints.large} {
    width: calc(25% - ${SPACING * 2}px);
  }

  img {
    display: block;
    width: 100%;
    max-width: 160px;
    margin: 0 auto;
  }
`
